var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigbox"},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_vm._v(" "),_c('imgPreview')],1)}
var staticRenderFns = []
export { render, staticRenderFns }